export default __webpack_public_path__ + "static/media/luggage.91ba81e3.svg";